/* MDS Birthday Sale: the PDP layer for the Flow Timer (sections/mds-flowtimer-v4) and Modular Planner
   (sections/mds-planner-system-v4) buy columns. Loaded only while the sale is on (the sections render the tag inside
   {% if bds_active %}), after assets/bds-sale-core.js (window.BDS).

   The sections own selection and Add to bag. Each one fires `bds:pdp` on its root ([data-bds-pdp]) whenever the selection
   changes and keeps the last detail on root._bdsPdp:
     Flow Timer  { buying: 'timer'|'bundle', vid, avail, addons: [{vid, qty}], cta }
     Planner     { full, sale, spend, mode }   (cents; Starter Bundle full/sale, spend = what Add to bag would add)
   Per-variant prices come from the section's <script data-bds-pdp-cfg> (snippets/bds-pdp-vrow: f = full, s = sale,
   p = %, st = status badge, cents). From that this file repaints the badge row, the price row, the plain gift line
   (SPEC 5.5), the compact gifts module (SPEC 5.8), the option card price and the "· $X" on Add to bag, and wires
   Build your bundle to the builder slide-out (BDSBuilder.slideout.open) with the builder page link as the fallback. */
(function () {
  'use strict';
  var esc = function (t) { return String(t == null ? '' : t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); };

  /* The plain gift line: what this spend alone earns, then where the next gift starts. Non-interactive. */
  function giftLine(B, units) {
    var t = B.M().tiers, s = B.state(units);
    var ok = ' <span class="bds-pline__ok" aria-hidden="true">' + B.ICON.check + '</span>';
    var from = function (i) { return '<b>' + B.money(t[i]) + '</b>'; };
    // one icon per gift, in tier order (truck, pencil, coasters), from BDS.tiers
    var ids = B.tiers.reduce(function (a, t) { return a.concat(t.gifts); }, []);
    var thumbs = ids.map(function (x) {
      return '<span' + (s.unlocked.indexOf(x) > -1 ? ' class="is-on"' : '') + '>' + B.giftVisual(x) + '</span>';
    }).join('');
    // "Free shipping ✓ · Free Metal Pencil from $100" / "Free shipping + Metal Pencil ✓ · Coasters from $150" / "Free shipping + both gifts ✓"
    // Names come from BDS.giftList, which keeps a proper name (the Metal Pencil) capitalised and lower-cases generic ones
    // mid-sentence (never .toLowerCase() here). The clause after the dot is one unbreakable unit, so a phone never wraps
    // "Coasters" away from its "from $150".
    var nx = function (h) { return '<span class="bds-pline__nx">' + h + '</span>'; };
    var gifts = s.next != null && s.next > 0 ? B.tiers[s.next].gifts : [];
    var txt = s.idx < 0 ? nx('Free gifts from ' + from(0))
      : s.next == null ? 'Free shipping + ' + B.allGifts() + ok
      : s.idx === 0 ? 'Free shipping' + ok + ' · ' + nx('Free ' + B.giftList(gifts, { lower: true }) + ' from ' + from(s.next))
      : 'Free shipping + ' + B.giftList(s.realGifts, { lower: true }) + ok + ' · ' + nx(B.giftList(gifts) + ' from ' + from(s.next));
    return '<span class="bds-pline__th" aria-hidden="true">' + thumbs + '</span><span class="bds-pline__t">' + txt + '</span>';
  }

  // stacked = the planner's row (snippets/bds-pdp-price): struck price over "Save $X  N% OFF", beside the sale price
  function priceRow(B, full, sale, note, stacked) {
    var m = function (c) { return B.money(c / 100, true); }, save = full - sale;
    var deal = save <= 0 ? ''
      : stacked ? '<span class="bds-price__stack"><s class="bds-price__was" data-bds-was>' + m(full) + '</s><span class="bds-price__saveline"><span class="bds-price__save" data-bds-save>Save ' + m(save) + '</span>' +
        '<span class="bds-disc" data-bds-pct>' + Math.round(100 * save / full) + '% off</span></span></span>'
      : '<s class="bds-price__was" data-bds-was>' + m(full) + '</s><span class="bds-price__save" data-bds-save>Save ' + m(save) + '</span>';
    return '<span class="bds-price__now" data-bds-now>' + m(sale) + '</span>' + deal + (note ? '<small class="bds-pprice__note">' + esc(note) + '</small>' : '');
  }

  function init(root) {
    if (root._bdsInit) return;
    var B = window.BDS;
    if (!B || !B.sale || !B.sale.active || !B.M) return;
    root._bdsInit = true;
    var cfg = {};
    try { cfg = JSON.parse(root.querySelector('[data-bds-pdp-cfg]').textContent) || {}; } catch (e) { cfg = {}; }
    var V = cfg.v || {}, kind = root.getAttribute('data-bds-pdp');
    var money = function (c) { return B.money(c / 100, true); };
    var $ = function (sel) { return root.querySelector(sel); };
    var last = null;

    function paintGifts(spendCents) {
      var units = Math.round(spendCents) / 100, s = B.state(units);
      var gl = $('[data-bds-pline]');
      if (gl) { gl.innerHTML = giftLine(B, units); gl.setAttribute('data-spend', units.toFixed(2)); }
      var t = $('[data-bds-pgc-t]');
      if (t) t.innerHTML = s.realGifts.length ? '<b>' + (s.realGifts.length > 1 ? 'Gifts' : 'Gift') + ' unlocked.</b> No code, no catch.' : '<b>' + esc(t.getAttribute('data-offer') || B.offerLine()) + '.</b> No code, no catch.';
      var sp = $('[data-bds-pgc-spend]'); if (sp) sp.innerHTML = B.spendLine(units, { bold: true });
      var mt = $('[data-bds-pgc-mt]'); if (mt) mt.innerHTML = B.milestones(units, { compact: true, cls: 'bds-mt--pdp' });
    }
    function paintBadges(status, pct) {
      var st = $('[data-bds-status]'), pc = $('[data-bds-pct]');
      if (st) { st.textContent = status || ''; st.hidden = !status; st.classList.toggle('is-low', /left|low/i.test(status || '')); }
      if (pc) { pc.textContent = pct + '% off'; pc.hidden = !(pct > 0); }
    }

    function paintFt(d) {
      var r = d && V[d.vid]; if (!r) return;
      var addons = (d.addons || []).reduce(function (sum, a) { var x = V[a.vid]; return sum + (x ? x.s : 0) * (a.qty || 1); }, 0);
      var spend = r.s + addons;
      var pr = $('[data-bds-pprice]');
      // keep the stacked layout (struck price over "Save $X  N% OFF") when the page rendered it that way
      var stk = !!(pr && pr.querySelector('.is-stacked'));
      if (pr) pr.innerHTML = '<span class="bds-price bds-price--pdp' + (r.f > r.s ? (stk ? ' is-stacked' : '') : ' is-regular') + '">' + priceRow(B, r.f, r.s, '', stk) + '</span>';
      paintBadges(r.st, r.p);
      var op = $('[data-bds-optprice="' + d.buying + '"]');
      if (op) op.innerHTML = '<span class="now">' + money(r.s) + '</span>' + (r.f > r.s ? '<span class="was">' + money(r.f) + '</span>' : '');
      paintGifts(spend);
      var cta = d.cta;
      if (cta && !cta.classList.contains('is-soldout') && !cta.classList.contains('is-loading') && cta.textContent.indexOf(' · ') < 0) cta.textContent += ' · ' + money(spend);
      var link = $('[data-bds-open-builder]');
      if (link) { link.setAttribute('data-handle', r.h); link.setAttribute('data-variant-id', d.vid); }
    }
    function paintMps(d) {
      if (!d) return;
      var pr = $('[data-bds-pprice]');
      if (pr) { var note = pr.querySelector('.bds-pprice__note'); pr.innerHTML = priceRow(B, d.full, d.sale, d.note != null ? d.note : (note ? note.textContent : ''), pr.classList.contains('is-stacked')); }
      paintBadges(($('[data-bds-status]') || {}).textContent || '', d.full > 0 ? Math.round(100 * (d.full - d.sale) / d.full) : 0);
      paintGifts(d.spend);
    }
    var paint = function (d) { last = d; (kind === 'mps' ? paintMps : paintFt)(d); };
    root.addEventListener('bds:pdp', function (e) { paint(e.detail); });
    if (root._bdsPdp) paint(root._bdsPdp); else paintGifts(+(($('[data-bds-pline]') || { getAttribute: function () { return 0; } }).getAttribute('data-spend')) * 100 || 0);

    /* Build your bundle -> the builder slide-out on the same cart (never adds anything by itself), else the page link */
    function prefill() {
      if (kind === 'mps') {
        var out = [], cov = $('[data-mps-swatch].is-active');
        if (cov && V[cov.dataset.variantId]) out.push({ handle: V[cov.dataset.variantId].h, id: +cov.dataset.variantId });
        var custom = root.dataset.mode === 'custom';
        [].forEach.call(root.querySelectorAll('[data-mps-insert]'), function (c) {
          var q = custom ? +c.dataset.qty : (c.dataset.starter === '1' ? 1 : 0), r = V[c.dataset.variantId];
          if (q > 0 && r) out.push({ handle: r.h, id: +c.dataset.variantId, qty: q });
        });
        return out;
      }
      var r = last && V[last.vid];
      return r ? [{ handle: r.h, id: +last.vid }] : [];
    }
    root.addEventListener('click', function (e) {
      var a = e.target.closest && e.target.closest('[data-bds-open-builder]'); if (!a) return;
      var S = window.BDSBuilder && window.BDSBuilder.slideout;
      if (!S || typeof S.open !== 'function') return;   // no slide-out on this page: follow the link to the builder page
      e.preventDefault();
      S.open(prefill(), { title: cfg.builderTitle || 'Build your bundle', opener: a });
    });

    /* sold-out colours: Enter / Space shows the "Sold out" label like a tap does, and never picks */
    root.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var sw = e.target.closest && e.target.closest('.is-soldout[data-so]'); if (!sw) return;
      e.preventDefault(); sw.classList.add('is-told'); clearTimeout(sw._bdsT); sw._bdsT = setTimeout(function () { sw.classList.remove('is-told'); }, 1600);
    });
    /* the planner's covers are buttons, not .bds-swatch spans, so they flash their label here on tap too */
    root.addEventListener('click', function (e) {
      var sw = e.target.closest && e.target.closest('.mps__swatch.is-soldout'); if (!sw) return;
      sw.classList.add('is-told'); clearTimeout(sw._bdsT); sw._bdsT = setTimeout(function () { sw.classList.remove('is-told'); }, 1600);
    });

  }

  function boot() { [].forEach.call(document.querySelectorAll('[data-bds-pdp]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
